(function() { module.exports = window["dash_table"]; }());